import PropTypes from 'prop-types'

import AtomProgressBar from '@s-ui/react-atom-progress-bar'

import {Indicator} from './ratingFeatureIndicator.js'
import {SIZES} from './settings.js'

export const Line = ({label, rating, size = SIZES.LARGE, showIndicator = true, indicatorTrailing, maxScore}) => {
  const percentage = rating * 10
  const hasLabel = !!label
  return (
    <>
      <div className="mt-RatingFeature-header">
        {hasLabel && <p className="mt-RatingFeature-label">{label}</p>}
        {showIndicator && <Indicator progress={rating} trailing={indicatorTrailing} maxScore={maxScore} />}
      </div>
      <AtomProgressBar
        isBorderless
        percentage={percentage}
        hideIndicator
        size={size}
        mainStrokeSize="large"
        isAnimatedOnChange
      />
    </>
  )
}

Line.displayName = 'RatingFeature.Line'
Line.propTypes = {
  indicatorTrailing: PropTypes.string,
  label: PropTypes.string,
  maxScore: PropTypes.number,
  rating: PropTypes.number.isRequired,
  showIndicator: PropTypes.bool,
  size: PropTypes.string
}
